import { useQuery } from "@tanstack/react-query"
import {
  getAuditLogs,
  getAuditLogsWithAccessionNumber,
  getAuditLogWithLogId,
} from "../api/auditLogs"

export const useAuditLogsData = ({ page, limit, filters }) =>
  useQuery({
    queryKey: ["audit-logs", page, limit, filters],
    queryFn: () => getAuditLogs({ page, limit, filters }),
    retry: false,
  })

export const useAuditLog = (logId) =>
  useQuery({
    queryKey: ["audit-log", logId],
    queryFn: () => getAuditLogWithLogId(logId),
    retry: false,
    enabled: !!logId,
  })

export const useAuditLogWithAccessionNumber = (accessionNumber) =>
  useQuery({
    queryKey: ["audit-log", accessionNumber],
    queryFn: () => getAuditLogsWithAccessionNumber(accessionNumber),
    retry: false,
    enabled: !!accessionNumber,
  })
